import { motion } from "framer-motion";

const easeOut = [0.22, 1, 0.36, 1];

// Line-by-line masked reveal for headings. Pass array of strings.
export const MaskedLines = ({ lines, className = "", delay = 0, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, ease: easeOut, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

// Scroll-triggered reveal wrapper
export const Reveal = ({ children, className = "", delay = 0, y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: easeOut, delay }}
  >
    {children}
  </motion.div>
);

export const RevealLine = ({ children, className = "", delay = 0 }) => (
  <span className="line-mask">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: easeOut, delay }}
    >
      {children}
    </motion.span>
  </span>
);
